import { DefaultLinkModel } from '@projectstorm/react-diagrams';

export class ASLinkModel extends DefaultLinkModel {
	constructor() {
		super({
			type: 'advanced'
		});
	}
}